// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bulletpoint"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 5H21M8 12H21M8 19H21M3 5.00391H3.00391V5H3V5.00391ZM3 12.0039H3.00391V12H3V12.0039ZM3 19.0039H3.00391V19H3V19.0039Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BulletpointIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bulletpoint',
    ref,
    icon: element,
  },
));

BulletpointIcon.displayName = 'BulletpointIcon';

export default BulletpointIcon;
